<template>
  <div class="ggtf-modal-overlay" :class="{ show: show }">
    <div class="ggtf-modal-content" @click.stop>
      <div class="ggtf-modal-header">
        <h3>{{ $t('_ggtf._hdxq') }}</h3>
        <button class="ggtf-close-btn" @click="show = false">
          <CloseCircleOutlined style="font-size: 22px" />
        </button>
      </div>
      <div class="ggtf-modal-body">
        <div class="ggtf-detail-cover">
          <img :src="current.img" :alt="current.title" class="ggtf-detail-image" />
        </div>
        <div class="ggtf-detail-info">
          <h4 class="ggtf-detail-title">{{ current.title }}</h4>
          <!-- <div class="ggtf-detail-code">{{ $t('_ggtf._hdbm') }}: {{ current.code }}</div> -->

          <div class="ggtf-detail-section">
            <h5>{{ $t('_ggtf._hdjs') }}</h5>
            <p class="ggtf-detail-desc">{{ current.content }}</p>
          </div>

          <div class="ggtf-detail-section">
            <!-- <h5>{{ $t('_ggtf._cyyq') }}</h5> -->
              <div class="">
                <i class="fas fa-dollar-sign"></i>
                {{ $t('_bq._tzdj') }}: ${{ current.price }}
              </div>
          </div>
        </div>
      </div>
      <div class="ggtf-modal-footer">
        <button class="ggtf-cancel-btn" @click="show = false">{{ $t('_ggtf._qx') }}</button>
        <button class="ggtf-confirm-btn" @click="onSubmit()">{{ $t('_bq._ljzf') }}</button>
      </div>
    </div>

    <!-- 密码输入框 -->
    <toast-password ref="pay" @sumbit="onPwdSubmit" :okText="$t('_ggtf._ljcy')"></toast-password>
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import ToastPassword from './ToastPassword.vue'
export default {
  name: 'AdvBuyVue',
  components: { ToastPassword, CloseCircleOutlined },
  data() {
    return {
      show: false,
      current: {},
      pay_code: '',
      amount: ''
    }
  },
  methods: {
    open(item, pay_code) {
      this.show = true
      this.current = item
      this.pay_code = pay_code
    },
    //立即购买
    onSubmit() {
      // if (this.amount < this.current.price_min) {
      //   this.$message.warning(this.$t('_ggtf._zdgm') + this.current.price_min)
      //   return
      // }

      // if (this.current.price_max > 0 && this.amount > this.current.price_max) {
      //   this.$message.warning(this.$t('_ggtf._zggm') + this.current.price_max)
      //   return
      // }
      this.$refs.pay.open()
    },
    onPwdSubmit(passwd) {
      console.log('密码', passwd)

      this.$message.loading({ content: this.$t('_ggtf._zfz'), key: 'msg' })

      let that = this
      this.$api.videoInvest
        .payInvest({
          code: this.pay_code,
          // amount: Number(this.amount),
          passwd: passwd
        })
        .then((res) => {
          if (res.code == 1) {
            that.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          that.$refs.pay.close()
          that.show = false
          that.$message.success({ content: res.msg, key: 'msg' })

          //重置
          that.$emit('success')
        })
        .catch(() => {
          //   hide()
        })
    }
  }
}
</script>

<style></style>
